import { Emphasis } from '@/components/Emphasis';
import { LabradorComponent } from '@/types/component';

export const LabradorEmphasis: LabradorComponent = ({ type, data, meta, descendants, ...props }) => {
  return <Emphasis content={data.content} {...props} />;
};
